module.exports =(function() {
  return function(context) {
    return (function() {
      var $o;
      $o = [];
      $o.push("<div class='comment-form-container js-comment-edit-form'>\n  <textarea class='js-comment-edit-textarea' id='edit-comment-body' rows='1'>" + this.body_text + "</textarea>\n  <div class='actions'>\n    <a class='button js-comment-edit-cancel small transparent'>Cancel</a>\n    <button class='button js-comment-edit-save secondary small'>Save</button>\n  </div>\n</div>");
      return $o.join("\n").replace(/\s(?:id|class)=(['"])(\1)/mg, "");
    }).call(context);
  };

}).call(this);



//////////////////
// WEBPACK FOOTER
// ./app/javascript/backbone/story/templates/comments/edit_form.js.hamlc
// module id = 1616
// module chunks = 18